<template>
    <v-container fluid>
        <v-row class="ma-4">
            <v-dialog v-model="dialog" persistent max-width="600px">
                <!-- Кнопка вызова диалогового окна -->
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="warning" dark v-bind="attrs" v-on="on">Добавить</v-btn>
                </template>
                <!-- Форма создания комплектубщей -->
                <v-card>
                    <v-card-title>
                        <span class="headline">Создание детали</span>
                    </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field label="Название детали*" required v-model="name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                        <v-select :items="get_sub_groups" label="Подгруппа" v-model="sub_group" item-text="name" item-value="_id"></v-select>
                                    </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-file-input show-size counter label="Изображение" v-model="image"></v-file-input>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">Закрыть</v-btn>
                    <v-btn color="warning" dark @click="save()">Сохранить</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <div class="blocks-list">
            <Accessory
                v-for="accessory in get_accessories"
                :key="accessory._id"
                :item="accessory"
                type="accessories"
                :small="false"
            />
        </div>
    </v-container>
</template>

<script>
import axios from "axios";
import Accessory from "@/components/accessories/Accessory";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "Accessories",
    data: () => ({
        dialog: false,
        name: null,
        image: null,
        sub_group: null,
    }),
    components: {
        Accessory,
    },
    created() {
        this.load_accessories();
        this.load_sub_groups({type: 'accessory'});
    },
    computed: {
        ...mapGetters(["get_accessories", "get_baseURL", 'get_sub_groups']),
    },
    methods: {
        ...mapActions(["load_accessories", "create_accessory", "add_image", 'load_sub_groups']),
        save() {
            if (!this.name || !this.image) return false;
            this.upload_image();
        },
        async upload_image() {
            let formData = new FormData();
            formData.append("file", this.image);

            const instance = await axios.create({
                baseURL: this.get_baseURL,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: localStorage.getItem("_token"),
                },
            });

            instance
                .post(`/accessories/image`, formData)
                .then( response => response.data)
                .then( data => {
                    this.create_accessory({ name: this.name, image: data.name, sub_group: this.sub_group });
                    this.name = null;
                    this.image = null;
                    this.dialog = false;
                })
                .catch( error => {
                    console.log(error);
                })
        },

    },
};
</script>